import { useState } from "react";
import { Menu, MenuItem, IconButton } from "@mui/material";
import { CheckCircleOutline, MoreVert, ContentCopy } from "@mui/icons-material";
import ChangeProjectMenuItem from "./ChangeProjectMenuItem";
import { useSimulations } from "contexts/SimulationsContext";
import ArchiveRunMenuItem from "./ArchiveRunMenuItem";
import EditRunMenuItem from "./EditRunMenuItem";
import usePage from "hooks/usePage";
import ShareRunMenuItem from "./ShareRunMenuItem";

export default function MutateRunMenu({ run }) {
  const { submitSuitability } = useSimulations();
  const [anchorEl, setAnchorEl] = useState(null);
  const { isUrbanPage, isVegetationPage } = usePage();
  const { setUrbanSimToDuplicate, createSimulation } = useSimulations();

  const closeMenu = () => setAnchorEl(null);

  return (
    <>
      <IconButton
        size="small"
        sx={(theme) => ({
          color: theme.palette.text.secondary,
          "&:hover": {
            color: theme.palette.text.primary,
          },
        })}
        onClick={(e) => {
          e.stopPropagation();
          setAnchorEl(e.currentTarget);
        }}
        title="More options"
      >
        <MoreVert />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={closeMenu}
        keepMounted
      >
        {isVegetationPage && <EditRunMenuItem run={run} onClick={closeMenu} />}
        <ShareRunMenuItem run={run} onClick={closeMenu} />
        {!run.suitability && run.status === "completed" && isVegetationPage && (
          <MenuItem
            onClick={(e) => {
              e.stopPropagation();
              submitSuitability(run.id);
              closeMenu();
            }}
          >
            <CheckCircleOutline sx={{ mr: 1 }} fontSize="small" />
            Run Suitability
          </MenuItem>
        )}
        <ChangeProjectMenuItem onClick={closeMenu} run={run} />
        {isUrbanPage && (
          <MenuItem
            onClick={() => {
              setUrbanSimToDuplicate(run);
              createSimulation("urban");
              closeMenu();
            }}
          >
            <ContentCopy sx={{ mr: 1 }} fontSize="small" />
            Duplicate to Project
          </MenuItem>
        )}
        <ArchiveRunMenuItem onClick={closeMenu} run={run} />
      </Menu>
    </>
  );
}
